import { TableColumns } from "../../../../core/models/dashboard/tableColumns";

export const columns: TableColumns[] = [
  {
    header: "In Hands Date",
    field: "inHandsDate",
    link: false,
    linkField: "",
    isDate: true,
    isNumber: false,
  },
  {
    header: "Order #",
    field: "orderNumber",
    link: true,
    linkField: "orderNumber",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Client",
    field: "clientName",
    link: true,
    linkField: "clientId",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Job Name",
    field: "jobName",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
    isLongValueTrimmed: true,
  },
  {
    header: "% Cost In",
    field: "costIn",
    link: true,
    linkField: "orderNumber",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Pre-Bill/Inv",
    field: "preBillInv",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Split",
    field: "split",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Total Merch",
    field: "totalMerch",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
];
